import {APP_VERSION, BRAND_NAME, LOG_ENVIRONMENT, PLAYER_ID} from "Setup/config";

export const sendLogglyEvent = (category, message, json = {}) => {
    try {
        if (typeof _LTracker !== 'undefined') {
            json = {
                ...json,
                playerId: PLAYER_ID,
                site: BRAND_NAME,
                version: APP_VERSION,
                environment: LOG_ENVIRONMENT
            };

            _LTracker.push({
                category,
                message,
                json
            });
        } else {
            // console.log('_LTracker() not defined');
        }
    } catch (e) {
        console.log(e);
    }
};
